const serverArr = ['meeting.diandianys.com', 'v.diandianys.com'];
const roomIdArr = ['60733762798', '81983566835'];
const channel = 1;
const serverURI = serverArr[channel];
const accessKey = 'demo_access';
const secretKey = 'demo_secret';
let accessToken = '';
const roomId = roomIdArr[channel];//1501501500//60733762798
let room;
let players = [];
var restJs

/**
 * 全局对象
 * AudioCodingType
 * VideoCodingType
 */

/**
 * 浏览器能力测试
 */
export function tee3getBrowserDetect() {
  return avdEngine.getBrowserDetect();
}

/**
 * 获得accessToken
 */
export function tee3getAccessToken() {
  restJs = new RestJs(serverURI);
  return new Promise((resolve, reject) => {
    restJs.getAccessToken(accessKey, secretKey, (token) => {
      accessToken = token;
      bus.$emit('onGetAccessToken', accessToken);
      Log('getAccessToken', accessToken);
      resolve(token);
    }, (error) => {
      console.error('getAccessToken', error);
      reject(error);
    });
  })
}

/**
 * 检查音视频设备是否可用
 * async
 */
export function tee3checkDevice() {
  return new Promise((resolve, reject) => {
    avdEngine.checkDevice().then(res => {
      Log('checkResult', res);
      resolve(res);
    }).otherwise(reject);
  })
}

/**
 * 获得所有设备
 */
export function tee3getAllDevices() {
  avdEngine.getAllDevices().then((alls) => {
    console.log(alls);
  });
}

/**
 * 呼叫设备
 * @param roomId
 * @param userId
 * @param uri
 * @returns {Promise<any>}
 */
export function tee3CallDevice(roomId, userId, name, uri) {
  return new Promise((resolve, reject) => {
    restJs.inviteDevice(accessToken, roomId, userId, name, uri, (res) => {
      resolve(res);
    });
  });
}

/**
 * 获取所有可用设备对象
 * async
 * @returns {Promise<any>}
 */
export function tee3getDeviceObject() {
  return new Promise((resolve, reject) => {
    avdEngine.getDeviceObject().then(alls => {
      Log('devices', alls);
      resolve(alls);
    }).otherwise(reject)
  });
}

/**
 * 有热插拔时更新设备
 * @returns {Promise<any>}
 */
export function tee3refreshDevice() {
  return new Promise((resolve, reject) => {
    avdEngine.refreshDevice().then(() => {
      Log('cameraMap', avdEngine.cameraMap);
      Log('microphoneMap', avdEngine.microphoneMap);
      resolve();
    });
  });

}

export function tee3getResolutionEnum() {
  avdEngine.getResolutionEnum().then(alls => {
    console.log(alls);
  })
}

/**
 * async
 * 初始化
 */
export function tee3init(accessToken, videoCoding = '0') {
  avdEngine.setVideoCoding(videoCoding);
  avdEngine.setAudioCoding('0');
  //可以设置视频相关的默认参数值
  // avdEngine.setDefaultVideoParams(640,360,ResolutionSetType.exact,25,500,700);
  //可以设置桌面共享相关的默认参数值
  //avdEngine.setDefaultScreenParams(1920,1080,5，10);
  return new Promise((resolve, reject) => {
    avdEngine.init(serverURI, accessToken).then(() => {
      Log('initSuccess')
      bus.$emit('initSuccess', 'ok');
      resolve();
    }).otherwise((error) => {
      console.error('initError', error);
      bus.$emit('initError', error);
      reject(error);
    });
  })

}

/**
 * 加入房间
 * @param roomId
 * @param userId
 * @param userName
 * @param userData
 * @param password
 * @returns {Promise<any>}
 */
export function tee3join(roomId, userId, userName, userData = '', password = '') {
  /**
   *如果有“没有设备不允许加会”的需求，可以通过下面二个方法来判断,具体调用参看文档
   *avdEngine.cameraMap
   *avdEngine.microphoneMap
   */
  Log('加会参数', roomId, userId, userName);
  return new Promise((resolve, reject) => {
    room = avdEngine.obtainRoom(roomId);
    room.join(userId, userName, userData, password).then(() => {
      Log('room ' + roomId + ' joinSuccess');
      registerRoomCallback();
      bus.$emit('joinSuccess', 'ok');
      resolve();
    }).otherwise((error) => {
      console.error('room ' + roomId + ' joinError', error);
      bus.$emit('joinError', error);
      reject();
    });
  })
}

/**
 * 关闭房间
 * @param reason
 * @returns {void|*}
 */
export function tee3LeaveRoom() {
  //Log('room.connectionInfoCollector', room.connectionInfoCollector);
  if (room.connectionInfoCollector && room.connectionInfoCollector.stop) {
    room.connectionInfoCollector.stop();  //停止收集网络情况
  }
  const reason = 1;
  //closeCameraAndPubVideo();
  tee3closeCameraAndPubVideo();
  return room.leave(reason).then(() => {
    room = null;
    bus.$emit('leaveSuccess');
    Log('leaveSuccess');
  }).otherwise(() => {
    console.error('leave error');
  });
}

/**
 * 获得room
 * @returns {*}
 */
export function tee3getRoom() {
  return room;
}

/**
 * 获得当前用户
 * @returns {null}
 */
export function tee3getSelfUser() {
  return room.selfUser;
}

/**
 * 获得参会者列表
 * @returns {*}
 */
export function tee3getPlayers() {
  return room.getParticipants();
}

/**
 * 预览摄像头及发布流
 */
export function openCameraAndPubVideo(localVideo) {
  let videos = room.selfUser.videos;
  if (videos && videos.length > 0) {
    var video = videos[0];
    video.previewAndPublish(localVideo).otherwise(alertError);
  }
}

/**
 * 打开指定摄像头
 * @param id
 * @param el
 * @returns {Promise<any>}
 */
export function tee3previewVideo(id, el) {
  const video = room.selfUser.getVideo(id);
  return new Promise((resolve, reject) => {
    video.preview(el).then(() => {
      Log(`摄像头${id}预览成功`);
      resolve();
    }).otherwise((error) => {
      console.error(`摄像头${id}预览失败`);
      reject(error);
    });
  });
}

/**
 * 发布指定摄像头
 * @param id
 * @returns {Promise<any>}
 */
export function tee3publishVideo(id) {
  const video = room.selfUser.getVideo(id);
  return new Promise((resolve, reject) => {
    video.publish().then(() => {
      Log(`摄像头${id}发布成功`);
      resolve();
    }).otherwise((error) => {
      console.error(`摄像头${id}发布失败`);
      reject(error);
    });
  });
}

/**
 * 获取本地摄像头状态
 * */
export function tee3videoStatus() {
  const selfUser = room.selfUser;
  const videos = selfUser.videos;
  let video;
  if (videos.length > 0) {
    video = selfUser.getVideo(videos[0].id);
  }
  return video.status || ''
}

/**
 * 关闭本地摄像头并取消发布
 */
export function tee3closeCameraAndPubVideo() {
  const selfUser = room.selfUser;
  const videos = selfUser.videos;
  let index = 0;
  videos.forEach(v => {
    const video = selfUser.getVideo(v.id);
    video.unpublish();
    video.unpreview();
    index++;
  });
  if (index === videos.length) {
    Log('本地所有设备关闭成功');
    bus.$emit('closeCameraAndPubVideo');
  }
}

/**
 * 打开麦克风
 * @param {String} microphoneId - 麦克风设备id
 */
export function tee3openMicrophone() {
  const user = tee3getSelfUser();
  return new Promise((resolve, reject) => {
    if (user.audio && user.audio.id) {
      let audio = user.getAudio(user.audio.id);
      audio.openMicrophone().then(() => {
        Log('打开麦克风成功');
        resolve();
      }).otherwise((error) => {
        console.error('openMicrophone error', error);
        reject(error);
      });
    }
  })
}

/**
 * 获取麦克风状态
 */
export function gettee3MicrophoneStatus() {
  const user = tee3getSelfUser();
  if (user.audio && user.audio.id) {
    let audio = user.getAudio(user.audio.id);
    return audio.status;
  }
}

/**
 * 关闭麦克风
 */
export function tee3closeMicrophone() {
  const user = tee3getSelfUser();
  if (user.audio && user.audio.id) {
    let audio = user.getAudio(user.audio.id);
    audio.closeMicrophone();
  }
}

/**
 * 屏幕共享发布
 */
export function tee3OpenScreenAndPub(local) {
  var screen = room.selfUser.getScreen();
  return new Promise((resolve, reject) => {
    screen.publish().then(() => {
      screen.preview(local);
      resolve();
    }).otherwise((error) => {
      reject(error);
      alertError(error);
    });
    setTimeout(function () {
      screen.cancelChooseDesktopMedia();
    }, 8000);
  });
}

/**
 * 屏幕共享预览
 * @param local
 */
export function tee3ScreenPreview(local) {
  var screen = room.selfUser.getScreen();
  screen.preview(local);
}

/**
 * 开始直播
 * @param roomId
 * @param userId
 * @param pushUrl
 * @returns {Promise<any>}
 */
export function tee3StartLive(roomId, userId, pushUrl) {
  return new Promise((resolve, reject) => {
    restJs.startLive(accessToken, roomId, userId, pushUrl, (res) => {
      resolve(res);
    });
  });
}

/**
 * 停止直播
 * @param roomId
 * @param userId
 * @returns {Promise<any>}
 */
export function tee3StopLive(roomId, userId) {
  return new Promise((resolve, reject) => {
    restJs.stopLive(accessToken, roomId, userId, (res) => {
      resolve(res);
    });
  });
}

/**
 * kick踢人
 * @param roomId
 * @param userId
 * @returns {Promise<any>}
 */
export function tee3kick(roomId, userId) {
  return new Promise((resolve, reject) => {
    restJs.kick(accessToken, roomId, userId, (res) => {
      resolve(res);
    });
  });
}

function alertError(error) {
  Log("============================alertError", error)
}

function subscrible(type, arr) {
  var room = tee3getRoom();
  var selfUser = room.selfUser;
  var subIds = type === 'video' ? selfUser.subVideoIds :
    type === 'audio' ? selfUser.subAudioIds : selfUser.subScreenIds;
  arr.forEach(item => {
    if (subIds.length > 0) {
      if (subIds.findIndex(id => item.id === id) < 0) {
        item.subscrible();
      }
    } else {
      item.subscrible();
    }
  });
}

function registerRoomCallback() {
  listenUser(room.getParticipants());
  subscrible('video', room.pubVideos);//加会登陆前，会议中已经发布的视频资源,采取订阅处理
  subscrible('screen', room.pubScreens); //加会登陆前，会议中已经发布的桌面共享资源,采取订阅处理);
  //room.addCallback(RoomCallback.connection_status, onConnectionStatus);
  //room.addCallback(RoomCallback.room_status_notify, onRoomStatusNotify);
  //room.addCallback(RoomCallback.connection_indicator, onConnectionIndicator);
  room.addCallback(RoomCallback.user_join_notify, (users) => {
    Log('onUserJoinNotify', users);
    listenUser(users);
    bus.$emit('onUserJoinNotify', users);
  });
  room.addCallback(RoomCallback.user_leave_notify, (opt, reason, user) => {
    Log('onUserLeaveNotify', opt, reason, user);
    bus.$emit('onUserLeaveNotify', opt, reason, user);
  });
  //room.addCallback(RoomCallback.leave_indication, onLeaveIndication);
  //room.addCallback(RoomCallback.close_room_result, onCloseRoomResult);
  //room.addCallback(RoomCallback.close_room_notify, onCloseRoomNotify);


  // room.addCallback(RoomCallback.app_data_notify, onAppdataNotify);
  // room.addCallback(RoomCallback.user_data_notify, onUserDataNotify);
  // room.addCallback(RoomCallback.user_name_notify, onUserNameNotify);
  //
  // room.addCallback(RoomCallback.public_message, onPublicMessage);
  // room.addCallback(RoomCallback.private_message, onPrivateMessage);
  // room.addCallback(RoomCallback.public_data, onPublicData);
  // room.addCallback(RoomCallback.private_data, onPrivateData);
  //
  room.addCallback(RoomCallback.mcu_peerconnection_completed, () => {
    Log('onMCUPeerConnectionCompleted')
    bus.$emit('onMCUPeerConnectionCompleted', 1);
    const statsInterval = 500; //sdk语音激励计算频率
    room.audioLevel.start(statsInterval).then(() => {
    });  //开始语音激励
    //room.audioLevel.stop().then(audioLevelStop); //停止语音激励
    const connectionInfoInterval = 2000; //网络情况收集计算频率
    Log('开始收集网络情况');
    room.connectionInfoCollector.start(connectionInfoInterval);
  });
//	room.addCallback(RoomCallback.pub_roomresourcemsg_rep_success, onPubRoomResourceMsgSuccess);
//	room.addCallback(RoomCallback.pub_roomresourcemsg_rep_error, onPubRoomResourceMsgError);
}

function listenUser(users) {
  users.forEach(user => {
    let selfUser = tee3getSelfUser();
    if (user.nodeId === selfUser.nodeId) {
      user.self = true;
      players.push(user);
    } else {
      players.push(user);
    }
    // user.addCallback(UserCallback.microphone_status_notify, onMicrophoneStatusNotify);
    // user.addCallback(UserCallback.camera_status_notify, onCameraStatusNotify);
    // user.addCallback(UserCallback.screen_status_notify, onScreenStatusNotify);
    //
    // user.addCallback(UserCallback.camera_data_notify, onCameraDataNotify);
    // user.addCallback(UserCallback.screen_data_notify, onScreenDataNotify);
    //
    user.addCallback(UserCallback.publish_camera_notify, (videos) => {
      Log('onPublishCameraNotify', videos);
      bus.$emit('onPublishCameraNotify', videos);
      subscrible('video', videos);
    });
    // user.addCallback(UserCallback.unpublish_camera_notify, onUnpublishCameraNotify);
    user.addCallback(UserCallback.subscrible_camera_result, (stream, userId, userName, cameraId) => {
      Log('onSubscribleCameraResult', stream, userId, userName, cameraId);
      bus.$emit('onSubscribleCameraResult', stream, userId, userName, cameraId);
    });
    // user.addCallback(UserCallback.unsubscrible_camera_result, onUnsubscribleCameraResult);
    //
    user.addCallback(UserCallback.publish_screen_notify, (screens) => {
      Log('onPublishScreenNotify', screens);
      subscrible('screen', screens);
    });

    user.addCallback(UserCallback.unpublish_screen_notify, (...args) => {
      Log('onUnpublishScreenNotify', args)
      bus.$emit('unScreenResult', args);
    });
    user.addCallback(UserCallback.subscrible_screen_result, (stream, userId, userName, screenId) => {
      Log('onSubscribleScreenResult', stream, userId, userName, screenId);
      bus.$emit('onSubscribleScreenResult', stream, userId, userName, screenId);
    });
    user.addCallback(UserCallback.unsubscrible_screen_result, (...args) => {
      Log('onUnsubscribleScreenResult', args);
    });
    //
    user.addCallback(UserCallback.publish_microphone_notify, (audios) => {
      Log('onPublishMicrophoneNotify', audios);
      bus.$emit('onPublishMicrophoneNotify', audios);
      subscrible('audio', audios);
    });//如果audioAutoSub的状态是false才会触发
    // user.addCallback(UserCallback.unpublish_microphone_notify, onUnpublishMicrophoneNotify);//如果audioAutoSub的状态是false才会触发
    user.addCallback(UserCallback.subscrible_microphone_result, (stream, userId, userName) => {
      Log('onSubscribleMicrophoneResult', stream, userId, userName);
      bus.$emit('onSubscribleMicrophoneResult', stream, userId, userName)
    });
    // user.addCallback(UserCallback.unsubscrible_microphone_result, onUnsubscribleMicrophoneResult);
    // user.addCallback(UserCallback.board_share_result, onBoardShareResult);
    // user.addCallback(UserCallback.board_close_result, onBoardCloseResult);
  });
}
